import $ from 'jquery';
import FJConstant from '../constants/FJConstant';
import FJDomUtil from '@src/util/FJDomUtil.js';

let _textarea = document.createElement('textarea');

const FJStringUtil = {
    getAudioBlobTypeFromAITool: function (url, blobType) {
        const ext = FJStringUtil.getPathSuffix(url);
        if (blobType === 'application/octet-stream') {
            let tempBlobType = blobType;
            switch (ext) {
                case 'mp3':
                    tempBlobType = 'audio/mpeg';
                    break;
                case 'wav':
                    tempBlobType = 'audio/wav';
                    break;
                default:
            }
            return tempBlobType;
        }
        return blobType;
    },
    getPathSuffix: function (path) {
        return path.substr(path.lastIndexOf('.') + 1).trim();
    },

    /**
     * @description 通过后缀获取媒体类型
     * @param suffix
     * @returns {string}
     */
    getMediaTypeFromSuffix: function (suffix) {
        // 通过后缀获取媒体类型
        let _suffix = suffix.toLowerCase();
        const videoSuffixList = ['mp4', 'mov', 'webm', 'm4v', 'avi', 'flv', 'mkv', 'wmv'];
        const imageSuffixList = ['png', 'jpg', 'webp', 'bmp', 'jpeg'];
        if (videoSuffixList.includes(_suffix)) {
            return FJConstant.VIDEO;
        } else if (imageSuffixList.includes(_suffix)) {
            return FJConstant.IMAGE;
        } else {
            return FJConstant.VIDEO;
        }
    },
    /**
     * @description 获取文件名
     * @param path
     * @param deleteExt
     * @returns {string}
     */
    getFileName: function (path, deleteExt) {
        if (!path) return '';
        let name = path.substr(path.lastIndexOf('/') + 1);
        if (deleteExt) name = name.split('.')[0];
        return name;
    },
    /**
     * @desc @desc 获取文件的后缀，如果没有的话则根据类型添加默认的后缀
     * @param {string} fileName
     * @param {[]} supportFormats - 支持的格式,全小写
     * @param {string} defaultFormat - 默认的后缀，当获取后缀为空或不正确时。全小写
     * @return {string}
     */
    getFileExtByName: function (fileName, supportFormats = [], defaultFormat = '') {
        if (!fileName) return defaultFormat;
        let ext = FJStringUtil.getPathSuffix(fileName);
        if (!ext || ext.length >= 5 || supportFormats.indexOf(ext.toLowerCase()) === -1) ext = '';

        if (ext === '') ext = defaultFormat;
        return ext;
    },
    /**
     * @desc 通过文件的类型来获取后缀
     * @param fileType
     * @param defaultExt
     * @param replaceMimeType
     * @return {*}
     */
    getExtByType(fileType, defaultExt, replaceMimeType = '') {
        if (!fileType) return defaultExt;
        return fileType
            .replace(replaceMimeType.toLowerCase(), '')
            .replace(replaceMimeType.toUpperCase(), '')
            .replace('/', '')
            .replace('_', '')
            .replace('.', '');
    },

    getTextSize: function (string = '', fontName, fontSize, fontStyle, fontWeight) {
        let style = 'normal',
            weight = 'normal';
        if (typeof fontStyle !== 'undefined') style = fontStyle;
        if (typeof fontWeight !== 'undefined') weight = fontWeight;
        let div = document.getElementById('textWidthPlaceholder');
        let text;
        let block;
        if (!div) {
            div = $(
                '<div id="textWidthPlaceholder" contenteditable="false" style="position: absolute;left: 0;top: -9999px"></div>',
            );
            block = $('<div style="display: inline-block; width: 1px; height: 0;"></div>');
            text = $(document.createElement('span'));
            $(div).append(text, block);
            $(document.body).append(div);
        } else {
            text = $($(div).find('span')[0]);
            block = $($(div).find('div')[0]);
        }

        text.css({
            'font-family': fontName,
            'font-size': fontSize,
            'font-style': style,
            'font-weight': weight,
            'white-space': 'nowrap',
        });
        text[0].innerHTML = 'gh';

        let result = {};
        let scale = 1.0;
        block.css({ verticalAlign: 'baseline' });
        result.ascent = (block.offset().top - text.offset().top) * scale;

        block.css({ verticalAlign: 'bottom' });
        result.height = $(text).height();
        result.descent = result.height - result.ascent;
        // $(text).text(string);
        text[0].innerHTML = string.replace(/ /g, '&nbsp;');
        result.width = $(text).width();
        return result;
    },

    strFirstCharToUpper: function (str) {
        if (!str) return '';
        try {
            let newStr = str.toLowerCase();
            return newStr
                .split(/\s+/g)
                .map(value => {
                    if (value && value.length !== 0) return `${value[0].toUpperCase()}${value.slice(1)}`;
                    else return '';
                })
                .join(' ');
        } catch (e) {
            console.log(e);
            return str;
        }
    },
    /**
     * @description 首字母大写
     * @param word
     * @return {*}
     */
    upperFirstLetter: function (word) {
        return word ? word.replace(/^\D/, word[0].toUpperCase()) : '';
    },
    /**
     * @description word首字母大写
     * @param str
     * @return {string}
     */
    upperWord: function (str) {
        if (!str) {
            return '';
        }

        const prepositionList = [
            'and',
            'of',
            'with',
            'for',
            'in',
            'on',
            'to',
            'by',
            'from',
            'but',
            'after',
            'back',
            'the',
            'along',
            'as',
            'a',
            'an',
            'over',
            'at',
        ];
        let arr = str.split(' ');
        let arrLength = arr.length;
        return arr
            .map((word, index) => {
                let lowerWorld = word.toLowerCase();
                return prepositionList.indexOf(word) === -1 || index === 0 || index === arrLength - 1
                    ? FJStringUtil.upperFirstLetter(lowerWorld)
                    : lowerWorld;
            })
            .join(' ');
    },

    /**
     * @desc decode转义字符
     * @param str
     * @return {*}
     */
    decodeString: function (str) {
        if (!str) return '';
        _textarea.innerHTML = str;
        return _textarea.value;
    },
    /**
     * @description 去掉字符串的无效字符
     * @param value
     * @return {*}
     */
    filterInvalidWord: function (value) {
        if (!value) {
            return '';
        }
        value = value.replace(/[`~!@#$%^&*()_+<>?:"{},.\/;\-'[\]]/g, ' ');
        value = value.trim().replace(/\s+/g, ' ');
        return value;
    },
    /**
     * @desc 将后缀改成小写
     * @param name
     * @return {string}
     */
    lowerCaseSuffix(name) {
        let result = name;
        // 将后缀改成小写
        if (name) {
            const index = name.lastIndexOf('.') + 1;
            if (index !== -1) {
                const ext = name.substring(index);
                if (ext.length <= 5) {
                    result = name.substring(0, index) + ext.toLowerCase();
                }
            }
        }
        return result;
    },
    deleteScriptText: function (str) {
        return str.replace(/<script>|<\/script>/g, '');
    },
    getEspText: function (name, fontSize, maxWidth) {
        if (!name || typeof name !== 'string') {
            return '';
        }
        let fileText;
        let fileExt = FJStringUtil.getPathSuffix(name);

        if (fileExt.length === 0 || fileExt.length >= 5) {
            return {
                fileTextType: 'NO EXT',
                fileName: name,
                fileText: name,
            };
        }

        const fontInfo = {
            fontFamily: 'Roboto',
            fontSize,
        };
        const fileName = name.replace('.' + fileExt, '');
        const extWidth = fileExt ? FJDomUtil.calcTextSize(fileExt, fontInfo).width : 0; // 后缀的宽度
        const nameWidth = FJDomUtil.calcTextSize(name, fontInfo).width; // 完整那么的宽度
        const lastChar = fileExt === '' ? fileName.slice(fileName.length - 4) : fileName[fileName.length - 1];
        const lastCharWidth = FJDomUtil.calcTextSize(lastChar, fontInfo).width;

        // 所能容纳下的最大宽度
        const filePureNameMaxWidth = maxWidth - extWidth - lastCharWidth;

        if (maxWidth > 0 && nameWidth > 0 && nameWidth >= maxWidth) {
            const ratio = filePureNameMaxWidth / nameWidth;
            let index = Math.floor(fileName.length * ratio);
            let text = fileName.slice(0, index);
            let textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;

            if (textWidth > filePureNameMaxWidth) {
                index--;
                while (textWidth < filePureNameMaxWidth && index > 10) {
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    index--;
                }
            } else if (textWidth < filePureNameMaxWidth) {
                index++;
                let oldText = text;
                while (textWidth > filePureNameMaxWidth) {
                    oldText = text;
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    if (textWidth === 0) {
                        textWidth = 99999;
                    }
                    index++;
                }
                text = oldText;
            }
            fileText = text + '...' + lastChar + '.' + fileExt;
        } else {
            fileText = name;
        }

        return {
            fileTextType: 'HAS EXT',
            fileName: fileName,
            fileText: fileText,
        };
    },
    getTextDataByUppercaseTypeAndRange(textData, uppercaseType, options = {}) {
        const { startIndex, endIndex } = options;
        let tempTextData = textData.map(item => {
            if (item === '') {
                return ' ';
            }
            return item;
        });

        let strLength = 0;

        // 将指定范围内的文本调整为全大写
        for (let i = 0; i < tempTextData.length; i++) {
            let str = tempTextData[i];
            const nowStrLength = str.length;

            let adjustedStartIndex = Math.max(startIndex - strLength, 0);
            let adjustedEndIndex = Math.min(endIndex - 1 - strLength, nowStrLength - 1);

            if (adjustedStartIndex <= adjustedEndIndex) {
                let prefix = str.substring(0, adjustedStartIndex);
                let uppercaseText = str.substring(adjustedStartIndex, adjustedEndIndex + 1);
                uppercaseText = this.getStrByUppercaseType(uppercaseText, uppercaseType);
                let suffix = str.substring(adjustedEndIndex + 1);

                tempTextData[i] = prefix + uppercaseText + suffix;
            }
            strLength += nowStrLength;
        }

        return tempTextData;
    },

    splitTextIntoSentences(text) {
        const splitRegex = /[。！？；]|(?=\D)[\.!\?](?=\D)/;
        const list = text.split(splitRegex).filter(item => item.trim());
        const list2 = list
            .map(
                item =>
                    item +
                    (text[text.indexOf(item) + item.length] && item.length > 1
                        ? text[text.indexOf(item) + item.length]
                        : ''),
            )
            .reduce((calc, cur) => {
                if (cur.length === 1) {
                    calc[calc.length - 1] += cur;
                } else calc.push(cur);
                return calc;
            }, []);
        return list2;
    },
    /**
     * @description 去除字符串中的非中文、字母、数字
     * @param {*} str
     * @returns
     */
    removeSymbols(str) {
        // 使用正则表达式匹配非字母、非数字和非中文字符，并替换为空字符串
        return str.replace(/[^\w\u4e00-\u9fa5]/g, '');
    },
    /**
     * @desc 计算两个字符串的相似度
     * @param {*} str1
     * @param {*} str2
     * @param {*} isMatchCase 是否区分大小写
     * @returns
     */
    calculateSimilarity(str1, str2, isMatchCase) {
        if (!isMatchCase) {
            str1 = str1.toLowerCase();
            str2 = str2.toLowerCase();
        }
        const m = str1.length;
        const n = str2.length;

        // 创建一个二维数组来存储计算结果
        const dp = Array.from(Array(m + 1), () => Array(n + 1).fill(0));

        // 初始化第一行和第一列
        for (let i = 0; i <= m; i++) {
            dp[i][0] = i;
        }
        for (let j = 0; j <= n; j++) {
            dp[0][j] = j;
        }

        // 计算编辑距离
        for (let i = 1; i <= m; i++) {
            for (let j = 1; j <= n; j++) {
                if (str1[i - 1] === str2[j - 1]) {
                    dp[i][j] = dp[i - 1][j - 1];
                } else {
                    dp[i][j] = Math.min(
                        dp[i - 1][j] + 1, // 删除操作
                        dp[i][j - 1] + 1, // 插入操作
                        dp[i - 1][j - 1] + 1, // 替换操作
                    );
                }
            }
        }

        // 返回相似度
        const maxLen = Math.max(m, n);
        const similarity = (maxLen - dp[m][n]) / maxLen;
        return similarity;
    },

    /**
     * @desc 判断字符串 str1 中是否包含 str2
     * @returns
     */
    doesStringExist(str1, str2) {
        const escapedA = str2.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(escapedA);
        return regex.test(str1);
    },

    /**
     * @description 判断字符串是否全是日文字符（包括平假名、片假名和部分汉字）
     * @param str
     * @returns {boolean}
     */
    isAllJapanese(str) {
        const kanjiRange = /[\u4e00-\u9faf\u3400-\u4dbf]/;
        const hiraganaRange = /[\u3040-\u309f]/;
        const katakanaRange = /[\u30a0-\u30ff\u31f0-\u31ff\uFF65-\uFF9F]/;
        const japaneseRange = new RegExp(`^(${kanjiRange.source}|${hiraganaRange.source}|${katakanaRange.source})+$`);
        return japaneseRange.test(str);
    },

    /**
     * @description 判断字符串是否全是简体中文字符
     * @param str
     * @returns {boolean}
     */
    isAllSimplifiedChinese(str) {
        const simplifiedChineseRange = /^[\u4e00-\u9fff]+$/;
        return simplifiedChineseRange.test(str);
    },

    /**
     * @description 判断字符串是否全是繁体中文字符
     * @param str
     * @returns {boolean}
     */
    isAllTraditionalChinese(str) {
        // 繁体中文的范围比较广泛且不完全，但可以大致判断
        const traditionalChineseRange = /^[\u3400-\u4dbf\u4e00-\u9fff\uF900-\uFAFF]+$/;
        return traditionalChineseRange.test(str);
    },

    /**
     * @description 字幕中的单词分割
     * @param strValue
     * @returns {*[]}
     */
    stringSplitWordInSubtitle(strValue) {
        let wordList = strValue.split(' ');
        let words = [];
        let spaceWord = '';
        const blankSpace = ' ';
        // 添加放错机制
        try {
            const _convertWord = word => {
                function splitJapaneseString(str) {
                    const hiragana = /[\u3040-\u309f]+/;
                    const katakanaCompound = [
                        'キャ',
                        'ギャ',
                        'シャ',
                        'ジャ',
                        'チャ',
                        'ヂャ',
                        'ニャ',
                        'ヒャ',
                        'ビャ',
                        'ピャ',
                        'ミャ',
                        'リャ',
                        'ヴャ',
                        'キュ',
                        'ギュ',
                        'シュ',
                        'ジュ',
                        'チュ',
                        'ヂュ',
                        'ニュ',
                        'ヒュ',
                        'ビュ',
                        'ピュ',
                        'ミュ',
                        'リュ',
                        'ヴュ',
                        'キョ',
                        'ギョ',
                        'ショ',
                        'ジョ',
                        'チョ',
                        'ヂョ',
                        'ニョ',
                        'ヒョ',
                        'ビョ',
                        'ピョ',
                        'ミョ',
                        'リョ',
                        'ヴョ',
                        'ファ',
                        'ツァ',
                        'ヴァ',
                        'テャ',
                        'デャ',
                        'トァ',
                        'ドァ',
                        'シャ',
                        'ジャ',
                        'チャ',
                        'クァ',
                        'グァ',
                        'フィ',
                        'ウィ',
                        'ツィ',
                        'ヴィ',
                        'ティ',
                        'ディ',
                        'トィ',
                        'ドィ',
                        'クィ',
                        'グィ',
                        'テュ',
                        'デュ',
                        'トゥ',
                        'ドゥ',
                        'シュ',
                        'ジュ',
                        'チュ',
                        'クゥ',
                        'グゥ',
                        'フェ',
                        'ウェ',
                        'ツェ',
                        'ヴェ',
                        'テェ',
                        'デェ',
                        'トェ',
                        'ドェ',
                        'シェ',
                        'ジェ',
                        'チェ',
                        'クェ',
                        'グェ',
                        'フォ',
                        'ウォ',
                        'ツォ',
                        'ヴォ',
                        'テョ',
                        'デョ',
                        'トォ',
                        'ドォ',
                        'ショ',
                        'ジョ',
                        'チョ',
                        'クォ',
                        'グォ',
                    ];

                    const katakanaRegex = new RegExp(katakanaCompound.join('|'), 'g');
                    const kanji = /[\u4e00-\u9faf\u3400-\u4dbf]/;
                    const other = /[^\u3040-\u309f\u30a0-\u30ff\u31f0-\u31ff\uFF65-\uFF9F\u4e00-\u9faf\u3400-\u4dbf]+/;

                    let result = [];
                    let temp = '';
                    let match;

                    const __splitByRegex = (str, ...regexes) => {
                        let result = [];
                        let temp = '';
                        let i = 0;

                        while (i < str.length) {
                            let matched = false;
                            for (let regex of regexes) {
                                if (regex.test(str[i])) {
                                    if (temp.length > 0) {
                                        result.push(temp);
                                        temp = '';
                                    }
                                    result.push(str[i]);
                                    matched = true;
                                    break;
                                }
                            }
                            if (!matched) {
                                temp += str[i];
                            }
                            i++;
                        }
                        if (temp.length > 0) {
                            result.push(temp);
                        }
                        return result;
                    };

                    // Match katakana compound first
                    while ((match = katakanaRegex.exec(str)) !== null) {
                        let index = match.index;
                        if (temp.length > 0) {
                            result.push(...__splitByRegex(temp, kanji, hiragana, other));
                            temp = '';
                        }
                        result.push(match[0]);
                        str = str.slice(0, index) + str.slice(index + match[0].length);
                    }

                    // Process remaining string
                    if (str.length > 0) {
                        result.push(...__splitByRegex(str, kanji, hiragana, other));
                    }

                    return result;
                }
                function isSimplifiedChinese(char) {
                    const simplifiedChineseRegex = /[\u4E00-\u9FFF]/;
                    return simplifiedChineseRegex.test(char);
                }

                function isTraditionalChinese(char) {
                    const traditionalChineseRegex = /[\u3400-\u4DBF\uF900-\uFAFF]/;
                    return traditionalChineseRegex.test(char);
                }

                function isHiragana(char) {
                    const hiraganaRegex = /[\u3040-\u309F]/;
                    return hiraganaRegex.test(char);
                }

                function isKatakana(char) {
                    const katakanaRegex = /[\u30A0-\u30FF]/;
                    return katakanaRegex.test(char);
                }

                function isJapanese(char) {
                    return isHiragana(char) || isKatakana(char);
                }

                function isPunctuation(char) {
                    const punctuationRegex = /[^\w\u4e00-\u9fa5]/;
                    return punctuationRegex.test(char);
                }

                function dealJapanBuffer(japanBuffer) {
                    return splitJapaneseString(japanBuffer);
                }

                function categorizeCharacters(input) {
                    const result = [];
                    let buffer = '';

                    for (let i = 0; i < input.length; i++) {
                        const char = input[i];

                        if (isSimplifiedChinese(char) || isTraditionalChinese(char)) {
                            if (buffer.length > 0) {
                                result.push(buffer);
                                buffer = '';
                            }
                            result.push(char);
                        } else if (isKatakana(char) || isHiragana(char)) {
                            if (buffer.length > 0) {
                                result.push(buffer);
                                buffer = '';
                            }
                            result.push(char);
                        } else if (isPunctuation(char)) {
                            if (result.length > 0) {
                                if (buffer.length > 0) {
                                    result.push(buffer + char);
                                    buffer = '';
                                } else {
                                    result[result.length - 1] += char;
                                }
                            } else {
                                if (buffer.length > 0) {
                                    result.push(buffer + char);
                                    buffer = '';
                                } else {
                                    buffer += char;
                                }
                            }
                        } else {
                            buffer += char;
                        }
                    }

                    // Push any remaining buffer content
                    if (buffer.length > 0) {
                        result.push(buffer);
                    }

                    return result;
                }

                return categorizeCharacters(word);
            };
            wordList.forEach((w, i) => {
                if (i === wordList.length - 1) {
                    if (w !== '') {
                        if (spaceWord) words.push(spaceWord);
                        words.push(..._convertWord(w));
                    } else {
                        if (spaceWord) words.push(spaceWord);
                    }
                } else if (w !== '') {
                    if (spaceWord) words.push(spaceWord);
                    words.push(..._convertWord(w));
                    words.push(blankSpace);
                    spaceWord = '';
                } else spaceWord += blankSpace;
            });
        } catch (e) {
            words = [];
            wordList.forEach((w, i) => {
                if (i === wordList.length - 1) {
                    if (w !== '') {
                        if (spaceWord) words.push(spaceWord);
                        words.push(w);
                    } else {
                        if (spaceWord) words.push(spaceWord);
                    }
                } else if (w !== '') {
                    if (spaceWord) words.push(spaceWord);
                    words.push(w);
                    words.push(blankSpace);
                    spaceWord = '';
                } else spaceWord += blankSpace;
            });
        }

        return words;
    },

    base64ToBlob(base64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 1024;
        let byteCharacters = atob(base64Data);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);

            let bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    },
    filterEmoji(str) {
        // const emojiRegex = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
        const emojiRegex =
            /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2700-\u27BF]|[\uD83C][\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDFFF\uFE0F]+|\uD83E[\uDD10-\uDDFF\uDE80-\uDEF3\uDF00-\uDFDF\uEA00-\uEA4F]/g;
        return str.replace(emojiRegex, '');
    },

    /**
     * @description 是否包含阿拉伯语或希伯来语
     * @param text
     * @returns {boolean}
     */
    onlyContainsArabic(text) {
        const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0590-\u05FF]/;
        return arabicRegex.test(text);
    },

    /**
     * @description 是否包含阿拉伯语
     * @param text
     * @returns {boolean}
     */
    containsArabic(text) {
        const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
        return arabicRegex.test(text) && !this.isAllArabicWithoutPunctuation(text);
    },

    isAllArabic(str) {
        const arabicRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/;
        return arabicRegex.test(str);
    },

    isAllArabicWithoutPunctuation(str) {
        const arabicRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/;
        const punctuationAndSpaceRegex = /[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/g;
        const cleanedStr = str.replace(punctuationAndSpaceRegex, '');
        return arabicRegex.test(cleanedStr);
    },

    sortWordListByArabic(wordList) {
        let words = [];
        let nonArabicWords = [];
        let arabicWords = [];

        wordList.forEach(word => {
            if (nonArabicWords.length === 0 && arabicWords.length === 0) {
                if (this.onlyContainsArabic(word)) {
                    arabicWords.unshift(word);
                } else {
                    nonArabicWords.push(word);
                }
            } else {
                if (this.onlyContainsArabic(word)) {
                    if (arabicWords.length > 0) {
                        arabicWords.unshift(word);
                    } else {
                        words = [...words, ...nonArabicWords];
                        nonArabicWords = [];
                        arabicWords.push(word);
                    }
                } else {
                    if (word === ' ') {
                        if (arabicWords.length > 0) {
                            arabicWords.unshift(word);
                        } else {
                            nonArabicWords.push(word);
                        }
                    } else {
                        if (arabicWords.length > 0) {
                            words = [...words, ...arabicWords];
                            arabicWords = [];
                            nonArabicWords.push(word);
                        } else {
                            nonArabicWords.push(word);
                        }
                    }
                }
            }
        });
        return [...words, ...nonArabicWords, ...arabicWords];
    },

    filteredString(name) {
        return name
            .replace(/[<>:"\/\\|?*\x00-\x1F]/g, '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .trim();
    },

    /**
     * @description 后台要求加入
     * @param str
     * @returns {string}
     */
    normalizeSpecialChars(str) {
        // 定义需要转换的Unicode区块配置
        const blocks = [
            // 数学符号区块（覆盖粗体/斜体/手写体等）
            [0x1d400, 0x1d419, 0x41], // Mathematical Bold Capital
            [0x1d41a, 0x1d433, 0x61], // Mathematical Bold Small
            [0x1d434, 0x1d44d, 0x41], // Mathematical Italic Capital
            [0x1d44e, 0x1d467, 0x61], // Mathematical Italic Small
            [0x1d468, 0x1d481, 0x41], // Mathematical Bold Italic Capital
            [0x1d482, 0x1d49b, 0x61], // Mathematical Bold Italic Small
            [0x1d49c, 0x1d4b5, 0x41], // Mathematical Script Capital
            [0x1d4b6, 0x1d4cf, 0x61], // Mathematical Script Small
            [0x1d504, 0x1d51d, 0x41], // Mathematical Fraktur Capital
            [0x1d51e, 0x1d537, 0x61], // Mathematical Fraktur Small
            [0x1d538, 0x1d551, 0x41], // Mathematical Double-Struck Capital
            [0x1d552, 0x1d56b, 0x61], // Mathematical Double-Struck Small
            [0x1d5a0, 0x1d5b9, 0x41], // Mathematical Sans-Serif Capital
            [0x1d5ba, 0x1d5d3, 0x61], // Mathematical Sans-Serif Small
            [0x1d5d4, 0x1d5ed, 0x41], // Mathematical Sans-Serif Bold Capital
            [0x1d5ee, 0x1d607, 0x61], // Mathematical Sans-Serif Bold Small
            [0x1d608, 0x1d621, 0x41], // Mathematical Sans-Serif Italic Capital
            [0x1d622, 0x1d63b, 0x61], // Mathematical Sans-Serif Italic Small
            [0x1d63c, 0x1d655, 0x41], // Mathematical Sans-Serif Bold Italic Capital
            [0x1d656, 0x1d66f, 0x61], // Mathematical Sans-Serif Bold Italic Small
            [0x1d670, 0x1d689, 0x41], // Mathematical Monospace Capital
            [0x1d68a, 0x1d6a3, 0x61], // Mathematical Monospace Small
            // 等宽字体（Monospace）
            [0x1d670, 0x1d689, 0x41], // Monospace Capital Letters
            [0x1d68a, 0x1d6a3, 0x61], // Monospace Small Letters
            // 等宽数字字体
            [0x1d7f6, 0x1d7ff, 0x30], // Monospace Digits
            // 全角字符
            [0xff21, 0xff3a, 0x41], // Fullwidth Latin Capital Letters
            [0xff41, 0xff5a, 0x61], // Fullwidth Latin Small Letters
            // 数学等宽体（Mathematical Monospace）
            [0x1d670, 0x1d689, 0x41], // Mathematical Monospace Capital
            [0x1d68a, 0x1d6a3, 0x61], // Mathematical Monospace Small
            // 衬线等宽体（Typewriter）
            [0x1d670, 0x1d689, 0x41], // Typewriter Capital
            [0x1d68a, 0x1d6a3, 0x61], // Typewriter Small
            // 圆圈字母（Circled Letters）
            [0x24b6, 0x24cf, 0x41], // Circled Latin Capital Letters
            [0x24d0, 0x24e9, 0x61], // Circled Latin Small Letters

            // 括号字母（Parenthesized Letters）
            [0x1f110, 0x1f129, 0x41], // Parenthesized Latin Capital Letters
            [0x249c, 0x24b5, 0x61], // Parenthesized Latin Small Letters

            // 方框字母（Squared Letters）
            [0x1f130, 0x1f149, 0x41], // Squared Latin Capital Letters
            [0x1f170, 0x1f189, 0x41], // Negative Squared Latin Capital Letters

            // 上标字母（Superscript）
            [0x1d2c, 0x1d45, 0x41], // Modifier Letter Capital
            [0x1d46, 0x1d7c, 0x61], // Modifier Letter Small

            // 下标字母（Subscript）
            [0x2090, 0x209c, 0x61], // Latin Subscript Small Letters

            // 小型大写字母（Small Capitals）
            [0x1d00, 0x1d25, 0x61], // Latin Small Capital Letters

            // 装饰性字母（Decorative Letters）
            [0x1f1e6, 0x1f1ff, 0x41], // Regional Indicator Symbols

            // 全角字符（Fullwidth）
            [0xff10, 0xff19, 0x30], // Fullwidth Digits
            [0xff21, 0xff3a, 0x41], // Fullwidth Latin Capital Letters
            [0xff41, 0xff5a, 0x61], // Fullwidth Latin Small Letters

            // 罗马数字（Roman Numerals）
            [0x2160, 0x2182, 0x49], // Roman Numerals
            [0x2185, 0x2188, 0x49], // Roman Numerals

            // 双线字母（Double-Struck）
            [0x1d538, 0x1d551, 0x41], // Double-Struck Capital Letters
            [0x1d552, 0x1d56b, 0x61], // Double-Struck Small Letters

            // 哥特体（Gothic/Fraktur）
            [0x1d504, 0x1d51d, 0x41], // Gothic Capital Letters
            [0x1d51e, 0x1d537, 0x61], // Gothic Small Letters

            // 手写体（Script）
            [0x1d49c, 0x1d4b5, 0x41], // Script Capital Letters
            [0x1d4b6, 0x1d4cf, 0x61], // Script Small Letters

            // 粗体手写体（Bold Script）
            [0x1d4d0, 0x1d4e9, 0x41], // Bold Script Capital Letters
            [0x1d4ea, 0x1d503, 0x61], // Bold Script Small Letters

            // 无衬线体（Sans-Serif）
            [0x1d5a0, 0x1d5b9, 0x41], // Sans-Serif Capital Letters
            [0x1d5ba, 0x1d5d3, 0x61], // Sans-Serif Small Letters

            // 无衬线粗体（Sans-Serif Bold）
            [0x1d5d4, 0x1d5ed, 0x41], // Sans-Serif Bold Capital Letters
            [0x1d5ee, 0x1d607, 0x61], // Sans-Serif Bold Small Letters

            // 无衬线斜体（Sans-Serif Italic）
            [0x1d608, 0x1d621, 0x41], // Sans-Serif Italic Capital Letters
            [0x1d622, 0x1d63b, 0x61], // Sans-Serif Italic Small Letters

            // 无衬线粗斜体（Sans-Serif Bold Italic）
            [0x1d63c, 0x1d655, 0x41], // Sans-Serif Bold Italic Capital Letters
            [0x1d656, 0x1d66f, 0x61], // Sans-Serif Bold Italic Small Letters

            // 数学字体数字（Mathematical Digits）
            [0x1d7ce, 0x1d7d7, 0x30], // Mathematical Bold Digits
            [0x1d7d8, 0x1d7e1, 0x30], // Mathematical Double-Struck Digits
            [0x1d7e2, 0x1d7eb, 0x30], // Mathematical Sans-Serif Digits
            [0x1d7ec, 0x1d7f5, 0x30], // Mathematical Sans-Serif Bold Digits
            [0x1d7f6, 0x1d7ff, 0x30], // Mathematical Monospace Digits

            // 数学粗体（Mathematical Bold）
            [0x1d400, 0x1d419, 0x41], // Mathematical Bold Capital
            [0x1d41a, 0x1d433, 0x61], // Mathematical Bold Small
            [0x1d6a8, 0x1d6c0, 0x391], // Mathematical Bold Greek Capital
            [0x1d6c1, 0x1d6e1, 0x3b1], // Mathematical Bold Greek Small

            // 数学斜体（Mathematical Italic）
            [0x1d434, 0x1d44d, 0x41], // Mathematical Italic Capital
            [0x1d44e, 0x1d467, 0x61], // Mathematical Italic Small
            [0x1d6e2, 0x1d6fa, 0x391], // Mathematical Italic Greek Capital
            [0x1d6fc, 0x1d71c, 0x3b1], // Mathematical Italic Greek Small

            // 数学粗斜体（Mathematical Bold Italic）
            [0x1d468, 0x1d481, 0x41], // Mathematical Bold Italic Capital
            [0x1d482, 0x1d49b, 0x61], // Mathematical Bold Italic Small
            [0x1d71c, 0x1d734, 0x391], // Mathematical Bold Italic Greek Capital
            [0x1d736, 0x1d756, 0x3b1], // Mathematical Bold Italic Greek Small
        ];

        return Array.from(str)
            .map(char => {
                const codePoint = char.codePointAt(0);
                let normalized = codePoint;

                // 遍历所有配置区块
                for (const [start, end, base] of blocks) {
                    if (codePoint >= start && codePoint <= end) {
                        normalized = codePoint - start + base;
                        break;
                    }
                }

                return String.fromCodePoint(normalized);
            })
            .join('');
    },
    getReloadNewUrl: function (url) {
        if (!url) return url; // 处理空字符串或未定义的情况

        // 检查是否已经包含 v 参数
        const hasVParam = url.includes('v=');
        const separator = url.includes('?') ? '&' : '?'; // 判断是否需要添加 ? 或 &

        if (hasVParam) {
            // 如果已经包含 v 参数，则覆盖其值
            return url.replace(/([?&]v=)[^&]*/, `$1${new Date().getTime()}`);
        } else {
            // 如果未包含 v 参数，则追加
            return `${url}${separator}v=${new Date().getTime()}`;
        }
    },
    getByteLen: function (str) {
        // return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'U').length;
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
        }
        return len;
    },
    /** 与 getByteLen 相同计数字节，截断到不超过 maxBytes */
    truncateToByteLen: function (str, maxBytes) {
        if (!str || maxBytes <= 0) return '';
        let len = 0;
        let end = 0;
        for (let i = 0; i < str.length; i++) {
            const add = str.charCodeAt(i) < 256 ? 1 : 2;
            if (len + add > maxBytes) break;
            len += add;
            end = i + 1;
        }
        return str.slice(0, end);
    },
    sliceByteLen: function (str, num) {
        if (!str || num <= 0) return '';

        let result = '';
        let asciiCount = 0;

        // 使用扩展运算符将字符串分解为字符数组
        for (const char of [...str]) {
            // 获取字符的 ASCII 值长度
            const charCode = char.charCodeAt(0);
            // ASCII 字符（0-127）计数为1，其他字符计数为2
            const charLength = charCode < 256 ? 1 : 2;

            // 检查是否超出限制
            if (asciiCount + charLength > num) {
                break;
            }

            result += char;
            asciiCount += charLength;
        }

        return result;
    },
};

export default FJStringUtil;
